import { Card, Col, Divider, Row, Space, Typography } from 'antd';
import React from 'react';

import { Link } from 'react-router-dom';
import ResourcesList from '../../courses/components/resourcesList';

const { Title } = Typography;

const ComponentItem = ({ component }) => {

    return (
        <Link to={`/app/course-components/${component.id}`}>
            <Card
                key={component.id}
                hoverable
                data-cy={'course-component-list-item'}
                style={{ marginTop: '20px' }}
                title={<Title level={4}>{component.title}</Title>}
                extra={<Space direction="horizontal"></Space>}
            >
                <Row>
                    <Col span={12}>{component.description}</Col>
                    <Col span={1}>
                        <Divider type="vertical" style={{ height: '100%' }} />
                    </Col>
                    <Col span={11}>
                        <ResourcesList
                            resources={{
                                file: component.file_resources,
                                link: component.link_resources,
                            }}
                            disabled={true}
                        />
                    </Col>
                </Row>
            </Card>
        </Link>
    );
};

export default ComponentItem;
